import _get from 'lodash/get'
import _isEmpty from 'lodash/isEmpty'

export class LogRecord {
  constructor (record) {
    this._record = record

    this.id = _get(record, 'id', '')
    this.logType = _get(record, 'type', '')
    this.logTime = _get(record, 'logTime', '')
    this.userId = _get(record, 'userId', '')
    this.logNotesType = _get(record, 'logNotes.type', '')
    this.logNotes = _get(record, 'logNotes.attributes', {})
  }

  get isNotEmptyLogNotes () {
    return !_isEmpty(this.logNotes)
  }
}
